import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { IUserData } from './manage-users.interface';

@Injectable()
export class ManageUsersService {
  private _API_BASE_URL: string = environment['API_URL'];

  public getList(): Observable<Array<IUserData>> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'usuari')
      .pipe(map(response => response || []));
  }

  public getCurr(usuari: string, lang: string, nombre: number): Observable<Array<any>> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'curriculum/' + usuari + '/lang/' + lang + '?nombre='+nombre)
      .pipe(map(response => response || {}));
  }

  public setCurr(usuari: string, lang: string, currData: any): Observable<string> {
//    console.log(currData);
    return this.authHttp.put<any>(this._API_BASE_URL + 'curriculum/' + usuari + '/idioma/' + lang, currData)
      .pipe(map(response => response || {}));
  }

  public create(newUserData: IUserData): Observable<IUserData> {
    return this.authHttp.post<any>(this._API_BASE_URL + 'usuari', newUserData)
      .pipe(map(response => response || {}));
  }

  public update(newUserData: IUserData): Observable<IUserData> {
    return this.authHttp.put<any>(this._API_BASE_URL + 'usuari/' + newUserData.id, newUserData)
      .pipe(map(response => response || {}));
  }

  public destroy(newUserData: IUserData): Observable<IUserData> {
    return this.authHttp.delete(this._API_BASE_URL + 'usuari/' + newUserData.id)
      .pipe(map(response => newUserData));
  }

  public setACL(newUserData: IUserData): Observable<IUserData> {
    return this.authHttp.put<any>(this._API_BASE_URL + 'usuari/' + newUserData.id + '/acl', newUserData)
      .pipe(map(response => response || {}));
  }

  constructor(private authHttp: HttpClient) {}

}
